import { __generator } from "tslib";
import { put, call, select, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as actionTypes from '../constants/actionTypes';
import { showHotspots, hideHotspots } from '../actionCreators';
var actions = [actionTypes.FLASH_HOTSPOTS, actionTypes.SHOW_SCREEN];
export default function flashHotspots() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actions, function (_a) {
                    var areHotspotHintsEnabled;
                    var type = _a.type;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, select(function (state) { return state.project.config.areHotspotHintsEnabled; })];
                            case 1:
                                areHotspotHintsEnabled = _b.sent();
                                if (!areHotspotHintsEnabled) {
                                    return [2 /*return*/];
                                }
                                if (!(type === actionTypes.FLASH_HOTSPOTS)) return [3 /*break*/, 4];
                                return [4 /*yield*/, put(showHotspots())];
                            case 2:
                                _b.sent();
                                return [4 /*yield*/, call(delay, 300)];
                            case 3:
                                _b.sent();
                                _b.label = 4;
                            case 4: 
                            // Need to hide hotspots immediately when transitioning to another screen
                            return [4 /*yield*/, put(hideHotspots())];
                            case 5:
                                // Need to hide hotspots immediately when transitioning to another screen
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
